<template>
  <section class="header-container" v-if="!rootStore.isMobile">
    <span class="title">{{ title }}</span>

    <search-menu
      v-if="hasArchives"
      :archive-id="archiveId"
      :folder-id="folderId"
      :allArchivesOnly="true"
      @search-completed="goToSearchResults"
    >
    </search-menu>
  </section>

  <section class="header-mobile" v-else>
    <section class="header-top">
      <search-menu
        v-if="hasArchives"
        :archive-id="archiveId"
        :folder-id="folderId"
        :allArchivesOnly="true"
        @search-completed="goToSearchResults"
      />
    </section>
    <section class="header-bottom">
      <span class="title">{{ title }}</span>
    </section>
  </section>
</template>
<script>
import SearchMenu from '@/features/filestore/children/SearchMenu.vue'
import { mapStores } from 'pinia'
import { useFileStoreStore } from '@/features/filestore/FileStore.store'

export default {
  components: { SearchMenu },
  props: ['archiveId', 'folderId'],
  data() {
    return {}
  },
  computed: {
    title() {
      return this.$route.meta.title
    },
    ...mapStores(useFileStoreStore),
    hasArchives() {
      return this.fileStoreStore.hasArchives
    }
  },
  methods: {
    goToSearchResults() {
      this.$router.push({ name: 'fileStoreSearchResults' })
    }
  }
}
</script>
<style lang="scss" scoped>
.header-container {
  display: grid;
  grid-template-columns: auto 40px;
  width: 100%;
  align-items: center;
}

.title {
  color: var(--sub-color);
  font-weight: 500;
  font-size: 13px;
}

.header-mobile {
  width: 100%;
  .header-top {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 24px;
    padding-right: 8px;
  }
  .header-bottom {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 24px;
  }
}
</style>
